module.exports = __webpack_public_path__ + "static/media/claim_status.d15d972e.JPG";